import * as React from 'react';

import { PoweredByCirium } from '../cirium/PoweredByCirium';
import { BrandingImage } from '../cirium/BrandingImage';
import styles from './ciriumCard.module.css';
import {
  Box,
  Flex,
  Heading3,
  Paragraph,
  thc,
} from '@flightstats/airframe-react';

const CardWrapper = thc(Flex, {
  boxShadow: '2px 2px 15px rgba(0,0,0,0.5)',
  borderRadius: 2,
  flexDirection: 'column',
  maxWidth: '400px',
  padding: {
    xs: '32px',
    sm: '32px 64px',
  },
});

type Props = {
  brandingImageUrl?: string | null;
  title: string;
  description: string | React.ReactNode;
  children?: React.ReactNode;
};

export const CiriumCard: React.FC<Props> = ({
  brandingImageUrl,
  title,
  description,
  children,
}) => (
  <Flex className={styles.ciriumCardFlex}>
    <CardWrapper>
      <Box className={styles.textAlignCenter}>
        {brandingImageUrl && (
          <BrandingImage marginBottom="10px" url={brandingImageUrl} />
        )}
        <Heading3 className={styles.spacing3} spacing={3}>{title}</Heading3>
        <Paragraph className={styles.spacing2} spacing={2} limitWidth={false}>
          {description}
        </Paragraph>
      </Box>
      {children}
      <PoweredByCirium className={styles.textAlignCenter} />
    </CardWrapper>
  </Flex>
);